import apiClient from "../../apiClient";
import { API_ENDPOINTS } from "../../config";

const salesDashboardService = {
  /**
   * Get sales dashboard analytics
   * @param {string} range - Date range: last_7_days, last_30_days, last_60_days, last_90_days
   * @returns {Promise<Object>} Dashboard data with kpis, funnelData, conversionMetrics, recentOpportunities
   */
  getSalesDashboard: async (range = 'last_30_days', startDate = '', endDate = '', managerId = 'all', executiveId = 'all') => {
    try {
      let query = `?range=${range}`;
      if (range === 'custom' && startDate && endDate) {
        query += `&startDate=${startDate}&endDate=${endDate}`;
      }
      if (managerId && managerId !== 'all') {
        query += `&managerId=${managerId}`;
      }
      if (executiveId && executiveId !== 'all') {
        query += `&executiveId=${executiveId}`;
      }
      
      const response = await apiClient.get(
        `${API_ENDPOINTS.CRM.SALES_DASHBOARD}${query}`
      );

      return {
        success: response.responseCode === 200,
        data: response.data
      };
    } catch (error) {
      
      return {
        success: false,
        error: error.response?.data?.responseMessage || "Failed to retrieve sales dashboard data",
        data: null
      };
    }
  }
};

export default salesDashboardService;


